import {RANGE_STATES} from '/component/base/RadioButton/filterRange.constants';

export const getDefaultFilterRangeDetails = () => ({
  options: [
    {
      text: 'New Clients',
      id: 'new_clients',
      selected: true,
      defaultVal: true,
    },
    {
      text: 'Qualified New Clients',
      id: 'q_new_clients',
      selected: false,
      defaultVal: false,
    },
  ],
  isFilterEnabled: false,
  minDigit: 0,
  maxDigit: 5,
  resultRangeState: RANGE_STATES.ABOVE,
  filterByText: 'New Clients',
  aboveValue: '',
  belowValue: '',
  isError: true,
  keyboardType: 'number-pad',
  isFloatAllowed: false,
  isNegativeNumAllowed: false,
});

export const getDefaultFQVDetails = () => ({
  options: [],
  isFilterEnabled: false,
  minDigit: -7,
  maxDigit: 7,
  resultRangeState: RANGE_STATES.ABOVE,
  filterByText: 'Estimated FQV',
  aboveValue: '',
  belowValue: '',
  isError: true,
  ValidationError: false,
  keyboardType: 'numbers-and-punctuation',
  isFloatAllowed: false,
  isNegativeNumAllowed: true,
});

export const getDefaultNewCoachesSponsoredDetails = () => ({
  options: [],
  isFilterEnabled: false,
  minDigit: 0,
  maxDigit: 5,
  resultRangeState: RANGE_STATES.ABOVE,
  filterByText: 'New Coaches Acquired',
  aboveValue: '',
  belowValue: '',
  isError: true,
  keyboardType: 'number-pad',
  isFloatAllowed: false,
  isNegativeNumAllowed: false,
});

export const buildFiltersDraft = (filters: any) => ({
  rankOptions: filters.rankOptions || [],
  bonusOptions: filters.bonusOptions || [],
  closeToNextRank: filters.closeToNextRank || false,
  newCoachesOptions: filters.newCoachesOptions || [],
  fibcOptions: filters.fibcOptions || [],

  fqvDetails: filters.fqvWithoutFilter
    ? {
        ...filters.fqvWithoutFilter,
        isNegativeNumAllowed: true,
        keyboardType: 'numbers-and-punctuation',
        isFloatAllowed: false,
      }
    : getDefaultFQVDetails(),

  filterRangeDetails: filters.filterRangeWithoutFilter
    ? {
        ...filters.filterRangeWithoutFilter,
        keyboardType: 'number-pad',
        isNegativeNumAllowed: false,
        isFloatAllowed: false,
      }
    : getDefaultFilterRangeDetails(),

  newCoachesSponsoredDetails: filters.newCoachesSponsoredWithoutFilter
    ? {
        ...filters.newCoachesSponsoredWithoutFilter,
        keyboardType: 'number-pad',
        isFloatAllowed: false,
        isNegativeNumAllowed: false,
      }
    : getDefaultNewCoachesSponsoredDetails(),
});
